"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FarmPoolParser = exports.STAKE_INFO_LAYOUT_V4 = exports.STAKE_INFO_LAYOUT = void 0;
const buffer_layout_1 = __importDefault(require("buffer-layout"));
const Layout = __importStar(require("../../../utils/layout"));
exports.STAKE_INFO_LAYOUT = buffer_layout_1.default.struct([
    Layout.uint64('state'),
    Layout.uint64('nonce'),
    Layout.publicKey('poolLpTokenAccount'),
    Layout.publicKey('poolRewardTokenAccount'),
    Layout.publicKey('owner'),
    Layout.publicKey('feeOwner'),
    Layout.uint64('feeY'),
    Layout.uint64('feeX'),
    Layout.uint64('totalReward'),
    Layout.uint128('rewardPerShareNet'),
    Layout.uint64('lastBlock'),
    Layout.uint64('rewardPerBlock')
]);
exports.STAKE_INFO_LAYOUT_V4 = buffer_layout_1.default.struct([
    Layout.uint64('state'),
    Layout.uint64('nonce'),
    Layout.publicKey('poolLpTokenAccount'),
    Layout.publicKey('poolRewardTokenAccount'),
    Layout.uint64('totalReward'),
    Layout.uint128('perShare'),
    Layout.uint64('perBlock'),
    buffer_layout_1.default.u8('option'),
    Layout.publicKey('poolRewardTokenAccountB'),
    buffer_layout_1.default.blob(7),
    Layout.uint64('totalRewardB'),
    Layout.uint128('perShareB'),
    Layout.uint64('perBlockB'),
    Layout.uint64('lastBlock'),
    Layout.publicKey('owner')
]);
const FarmPoolParser = (pubkey, info) => {
    if (info == null) {
        throw new Error("Info can not be null");
    }
    let farmPoolInfo;
    const buffer = Buffer.from(info.data);
    if (buffer.length === exports.STAKE_INFO_LAYOUT.span) {
        farmPoolInfo = exports.STAKE_INFO_LAYOUT.decode(buffer);
    }
    else if (buffer.length === exports.STAKE_INFO_LAYOUT_V4.span) {
        farmPoolInfo = exports.STAKE_INFO_LAYOUT_V4.decode(buffer);
    }
    const details = {
        pubkey,
        account: Object.assign({}, info),
        info: farmPoolInfo,
    };
    return details;
};
exports.FarmPoolParser = FarmPoolParser;
